import React from "react";
import { useMap } from "react-map-gl";
import FileSaver from "file-saver";
import html2canvas from "html2canvas";

import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";

function SidebarButtonDownload() {
	const { map } = useMap();

	const downloadMap = async () => {
		const fileName = `high-streets-map-explorer-export.png`;

		const mapboxCanvas = map.getCanvas();
		const legendHtml = document.getElementById("legend");
		
		if (legendHtml?.style?.visibility === "hidden") {
			mapboxCanvas.toBlob((blob) => {
				FileSaver.saveAs(blob, fileName);
			});
			return;
		}

		const legendCanvas = await html2canvas(legendHtml);
		const merge = document.createElement("canvas");
		merge.width = mapboxCanvas.width;
		merge.height = mapboxCanvas.height;

		const context = merge.getContext("2d");
		context.globalAlpha = 1.0;
		context.drawImage(mapboxCanvas, 0, 0);
		context.globalAlpha = 1.0;
		context.drawImage(legendCanvas, 10, 10);

		merge.toBlob((blob) => {
			FileSaver.saveAs(blob, fileName);
		});
	};

	return (
		<Button
			id="download-map-view-button"
			variant="outlined"
			startIcon={<DownloadIcon />}
			onClick={downloadMap}
			sx={{
				width: "100%",
				height: "100%",
			}}>
			Download Map View
		</Button>
	)
}

export default SidebarButtonDownload;